export default "__VITE_ASSET__Dwv3dOhO__"